const t = {
  xs: "d-avatar--xs",
  sm: "d-avatar--sm",
  md: "d-avatar--md",
  lg: "d-avatar--lg",
  xl: "d-avatar--xl"
}, _ = {
  default: "",
  icon: "d-avatar__icon",
  initials: "d-avatar__initials"
}, s = {
  md: "d-avatar__presence--md",
  lg: "d-avatar__presence--lg"
}, n = {
  NONE: "",
  BUSY: "busy",
  AWAY: "away",
  OFFLINE: "offline",
  ACTIVE: "active"
}, R = {
  xs: "100",
  sm: "200",
  md: "300",
  lg: "500",
  xl: "600"
}, a = [
  "000",
  "100",
  "200",
  "300",
  "400",
  "500",
  "600",
  "700",
  "800",
  "900",
  "1000",
  "1100",
  "1200",
  "1300",
  "1400",
  "1500",
  "1600",
  "1700",
  "1800"
], c = a.slice(1), d = (A) => A > 1, E = {
  AVATAR_SIZE_MODIFIERS: t,
  AVATAR_KIND_MODIFIERS: _,
  AVATAR_PRESENCE_SIZE_MODIFIERS: s,
  AVATAR_PRESENCE_STATES: n,
  AVATAR_ICON_SIZES: R,
  AVATAR_COLORS: a,
  AVATAR_RANDOM_COLORS: c,
  AVATAR_GROUP_VALIDATOR: d
};
export {
  a as AVATAR_COLORS,
  d as AVATAR_GROUP_VALIDATOR,
  R as AVATAR_ICON_SIZES,
  _ as AVATAR_KIND_MODIFIERS,
  s as AVATAR_PRESENCE_SIZE_MODIFIERS,
  n as AVATAR_PRESENCE_STATES,
  c as AVATAR_RANDOM_COLORS,
  t as AVATAR_SIZE_MODIFIERS,
  E as default
};
//# sourceMappingURL=avatar-constants.js.map
